import { DashboardService } from '@/services/DashboardService';
import { useState } from 'react';

const useDashboard = () => {
  const [ count, setCount ] = useState();
  const [ errorDashboard, setErrorDashboard] = useState(false);
  const getCountBusiness = async ( mes: number, ano: number ) => {
    try{
      const response = await DashboardService.getContagemBusiness(mes + 1, ano);
      if(response){
        return response;
      }
    }catch(e){
      console.error('Deu ruim!\n', e);
      setErrorDashboard(true);
    }
  };

  const getSumBusiness = async ( mes: number, ano: number) => {
    try {
      const response = await DashboardService.getSumBusiness(mes + 1, ano);
      if(response){
        return response;
      }
    } catch(e) {
      console.error('Erro!\n', e);
    }
  }

  const getCountByGroup = async ( mes: number, ano: number) => {
    try {
      const response = await DashboardService.getCountGroup(mes+ 1, ano);
      if(response){
        return response;
      }
    } catch (e) {
      console.error(e)
    }
  }

  const getFinished = async ( mes: number, ano: number) => {
    try {
      const response = await DashboardService.getFinished(mes + 1, ano);
      if (response){
        return response;
      }
    } catch (e) {
      console.error(e);
    }
  } 

  const getPendentes = async ( mes: number, ano: number) => {
    try{
      const response = await DashboardService.getPendentes( mes, ano);
      if(response){
        return response;
      }
    } catch (e) {
    console.error(e);
  }
}

  const getSumByGroup = async ( mes: number, ano: number) =>{
    try {
      const response = await DashboardService.getSumByGroup(mes+1, ano);
      if(response){
        return response;
      }
    } catch(e){
      console.error(e);
    }
  }

  return {
   getSumByGroup,
   getCountBusiness,
   getSumBusiness,
   getCountByGroup,
   getFinished,
   getPendentes
  };

};

export default useDashboard;
